import Utils from "../utils/utils"

export class LearningObject {
    // TODO create models for all the arrays
    public id: number
    public title: string
    public description: string
    public duration: string
    public gradeRanges: string
    public grades: string[] = []
    public mediaType: string[] = []
    public posterImage: string
    public posterImages: any[] = []
    public posterImageUrl: string
    public searchDisplayImage: string
    public type: string
    public uri: string
    public languages: string[] = []
    public canonicalUrl: string
    public brand: string
    public subject: any
    public supportMaterials: string[] = []
    public resourcesCount: string
    public additionalFeatures: string[] = []
    public project: any

    public constructor(input: object) {
        if (input) {
            Object.keys(input).map((key) => {
                const property = Utils.convertToCamelcase(key)
                this[property] = input[key]
            })
        }
        this.escapePosterImageUrls()
    }

    public hasSupportMaterials() {
        if (this.additionalFeatures.indexOf("Support Materials") !== -1) {
            return true
        }
        return this.supportMaterials.length > 0
    }

    public getSupportMaterialsCount() {
        if (!this.supportMaterials) {
            return 0
        }
        return this.supportMaterials.filter(
            (role) => role !== "About This Resource"
        ).length
    }

    public isCollection() {
        return this.mediaType.indexOf("Collection") !== -1
    }

    public getPosterImage(width?: number, height?: number, type?: string) {
        let url
        if (type) {
            url = this.getPosterImageIfExists(type, width, height)
            if (url) {
                return url
            }
        }
        url = this.getPosterImageIfExists("original", width, height)
        if (url) {
            return url
        }
        url = this.getPosterImageIfExists("default", width, height)
        if (url) {
            return url
        }
        if (this.posterImage) {
            return this.posterImage
        }
        return null
    }

    public getPosterImageIfExists(
        type: string,
        width?: number,
        height?: number
    ) {
        return Utils.getITSImageIfExists(this.posterImages, type, width, height)
    }

    public getPosterImageAlt(type?: string) {
        if (!this.posterImages) {
            return this.title
        }
        if (type) {
            const posterImage = this.posterImages.find(
                (image) => image.type === type
            )
            if (posterImage) {
                return posterImage.alt_text
            }
        }
        if (this.posterImages && this.posterImages.length > 0) {
            return this.posterImages[0].alt_text
        }
        return this.title
    }

    public getRouterLink(linkForSupportMaterial: boolean = false) {
        const canonicalURLParts = (this.canonicalUrl || "")
            .split("/")
            .filter((p) => p.length)
        if (canonicalURLParts.length < 2) {
            return ["/"]
        }
        if (this.isCollection()) {
            const slugsPart = (this.canonicalUrl || "")
                .split("/collection/")
                .slice(-1)[0]
            const slugs = slugsPart.split("/").filter((p) => p.length)
            return ["/", "collection"].concat(slugs)
        }
        const slug = canonicalURLParts[canonicalURLParts.length - 1]
        const code = canonicalURLParts[canonicalURLParts.length - 2]
        if (this.getSupportMaterialsCount() && linkForSupportMaterial) {
            return ["/", "resource", code, slug, "support-materials"]
        }
        return ["/", "resource", code, slug]
    }

    private escapePosterImageUrls() {
        this.posterImage = Utils.escapePosterImage(this.posterImage)
        this.posterImages = Utils.escapePosterImage(this.posterImages)
        this.posterImageUrl = Utils.escapePosterImage(this.posterImageUrl)
        this.searchDisplayImage = Utils.escapePosterImage(
            this.searchDisplayImage
        )
    }
}
